function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#E0F1FF",
  d: "M0-14.785l5-8.66L993.508 547.27l-5 8.66zM12.5-36.435l5-8.66 988.508 570.714-5 8.66zM25-58.087l5-8.66 988.507 570.715-5 8.66zM37.5-79.737l5-8.66 988.508 570.715-5 8.66zM50-101.388l5-8.66 988.507 570.715-5 8.66zM62.5-123.038l5-8.66 988.507 570.715-5 8.66zM75-144.689l5-8.66 988.507 570.715-5 8.66zM87.5-166.34l5-8.66 988.507 570.715-5 8.66z"
});

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 566,
  cy: 209.909,
  r: 209,
  fill: "#F3F9FF",
  stroke: "#F3F9FF",
  strokeWidth: 18
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 566,
  cy: 209,
  r: 200,
  stroke: "#E0F1FF",
  strokeWidth: 10
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 566,
  cy: 209,
  r: 175,
  stroke: "#E0F1FF",
  strokeWidth: 10
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 566,
  cy: 209,
  r: 150,
  stroke: "#E0F1FF",
  strokeWidth: 10
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 566,
  cy: 209,
  r: 125,
  stroke: "#E0F1FF",
  strokeWidth: 10
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 566,
  cy: 209,
  r: 100,
  stroke: "#E0F1FF",
  strokeWidth: 10
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 566,
  cy: 209,
  r: 75,
  stroke: "#E0F1FF",
  strokeWidth: 10
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 566,
  cy: 209,
  r: 50,
  stroke: "#E0F1FF",
  strokeWidth: 10
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  cx: 566,
  cy: 209,
  r: 25,
  stroke: "#E0F1FF",
  strokeWidth: 10
});

function SvgPricingPage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1082,
    height: 324,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

export default "data:image/svg+xml;base64,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";
export { SvgPricingPage as ReactComponent };